import { Box, Typography, IconButton, Collapse } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { ExpandableSectionProps } from '../types';

interface ExpandableSectionWithArrowProps extends ExpandableSectionProps {
    hideArrow?: boolean;
}

export const ExpandableSection = ({
    title,
    isExpanded,
    onToggle,
    children,
    hideArrow = false,
}: ExpandableSectionWithArrowProps) => (
    <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body2" color="text.secondary">
                {title}
            </Typography>
            {!hideArrow && (
                <IconButton size="small" onClick={onToggle} sx={{ p: 0.5 }}>
                    {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
            )}
        </Box>
        <Collapse in={isExpanded}>{children}</Collapse>
    </Box>
);
